import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';

const REWARD_FIELDS = [
    { key: 'topThreeReward', label: 'Топ-3' },
    { key: 'topTenReward', label: 'Топ-10' },
    { key: 'defaultReward', label: 'Остальные' }
];

// Модалка настроек легенды: параметры QR-кода и настройки наград.
export default function SettingsModal({ legends, legendsState, onClose }) {
    const [qrBg, setQrBg] = useState(legends.qrBgColor || '#FFFFFF');
    const [qrColor, setQrColor] = useState(legends.qrCodeColor || '#000000');
    const [reward, setReward] = useState({ topThreeReward: 0, topTenReward: 0, defaultReward: 0 });

    useEffect(() => {
        let active = true;
        legendsState.getRewardConfig().then(data => {
            if (active && data) {
                setReward({
                    topThreeReward: data.topThreeReward ?? 0,
                    topTenReward: data.topTenReward ?? 0,
                    defaultReward: data.defaultReward ?? 0
                });
            }
        });
        return () => { active = false; };
    }, [legendsState]);

    const setRewardField = (key) => (e) => {
        const num = Math.max(0, parseInt(e.target.value, 10) || 0);
        setReward(prev => ({ ...prev, [key]: num }));
    };

    const saveQr = () => legendsState.saveGame({ qrBgColor: qrBg, qrCodeColor: qrColor });
    const saveReward = () => legendsState.saveRewardConfig(reward);

    return (
        <Modal open kicker="Настройки" title="Настройки игры" onClose={onClose}>
            <div className="lg-setgrid">
                <div className="set-card">
                    <h2>Параметры QR-кода</h2>
                    <div className="lg-colors">
                        <div className="lg-color">
                            <input type="color" value={qrBg} onChange={(e) => setQrBg(e.target.value)} />
                            <span>Цвет фона</span>
                        </div>
                        <div className="lg-color">
                            <input type="color" value={qrColor} onChange={(e) => setQrColor(e.target.value)} />
                            <span>Цвет QR</span>
                        </div>
                    </div>
                    <div className="set-acts">
                        <button type="button" className="btn btn-success" onClick={saveQr}>Сохранить</button>
                    </div>
                </div>

                <div className="set-card">
                    <h2>Настройки наград</h2>
                    {REWARD_FIELDS.map(({ key, label }) => (
                        <div className="set-field" key={key}>
                            <LabeledInput label={label} type="number" value={String(reward[key])} onChange={setRewardField(key)} />
                        </div>
                    ))}
                    <div className="set-acts">
                        <button type="button" className="btn btn-success" onClick={saveReward}>Сохранить</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

SettingsModal.propTypes = {
    legends: PropTypes.shape({ qrBgColor: PropTypes.string, qrCodeColor: PropTypes.string }).isRequired,
    legendsState: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
